export function tryParseJson(data) {
  try {
    return JSON.parse(data);
  } catch (e) {
    return null;
  }
}

export interface ResolvablePromise<T> extends Promise<T> {
  resolve: (data?: T) => void;
  reject: (error?: any) => void;
  fulfilled?: boolean;
}

export interface TimedPromise<T> extends ResolvablePromise<T> {
  clearTimeout: () => void;
}

export function createResolvablePromise<T>() {
  let resolve, reject;
  const promise: any = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  promise.resolve = (data) => {
    promise.fulfilled = true;
    resolve(data);
  };
  promise.reject = (error) => {
    promise.fulfilled = true;
    reject(error);
  };
  return promise as ResolvablePromise<T>;
}

export function createTimedPromise<T>(rejectFn: () => any, time?: number) {
  const promise = createResolvablePromise<T>();
  const result: any = promise;
  if (time) {
    const timeout = setTimeout(() => {
      promise.reject(rejectFn());
    }, time);
    const clear = () => clearTimeout(timeout);
    result.clearTimeout = clear;
    const { resolve, reject } = promise;
    result.resolve = (result) => {
      clear();
      resolve(result);
    };
    result.reject = (error) => {
      clear();
      reject(error);
    };
  } else {
    result.clearTimeout = () => {};
  }
  return result as TimedPromise<T>;
}
